import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import {
	getUser,
	getUserJobTypeOptionData,
	getUserInterestOptionData,
	getIgMedia,
	getUserProfessionOptionData,
	getUserCareerOptionData,
} from 'actions/user';

import { mapUserLevel, isExist } from 'util/helper';
import { sessionStorage } from 'util/storage';
import { syncUserSettingFromLocalStorage } from 'actions/bind';

export default store => ({
	path: 'settings',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'settings',
				),
			store,
			'SETTINGS',
		),
		onEnter: withAsyncEnterLoader(
			async (_, __, updateRatio) => {
				updateRatio(0.3);

				await store.dispatch(getUser());

				const { user } = store.getState();

				if (mapUserLevel(user.data.levelId) === 'REGISTERED') {
					const userForm = sessionStorage.getItem('userForm');

					if (isExist(userForm)) {
						store.dispatch(syncUserSettingFromLocalStorage(JSON.parse(userForm)));
					}
				}

				updateRatio(0.8);
				await Promise.all([
					store.dispatch(getUserJobTypeOptionData()),
					store.dispatch(getUserInterestOptionData()),
					store.dispatch(getIgMedia()),
					store.dispatch(getUserProfessionOptionData()),
					store.dispatch(getUserCareerOptionData()),
				]);
			},
			store,
			'ENTER_SETTINGS',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/User/Settings/index.js